import { getPath } from '@/router/common'

const baseUrl = {
  title: '满载率指标',
  path: 'Vehiclemanage'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'Vehiclemanage_Index',
    component: () => import(/* webpackChunkName: "Vehiclemanage_Index" */ '@/views/vehiclemanage/index/index.vue'),
    meta: {
      title: '满载率指标'
    }
  },
  {
    path: getPath('AddOrEdit', baseUrl),
    name: 'Vehiclemanage_AddOrEdit',
    component: () => import(/* webpackChunkName: "Vehiclemanage_AddOrEdit" */ '@/views/vehiclemanage/addOrEdit/index.vue'),
    meta: {
      title: '新增修改满载率指标'
    }
  }
]
